import { AddEdit as AddEditInterface } from '../../../../interfaces/transaction.interface';
import { Validation } from '../../../../interfaces/common';
import { APP_ERROR_MESSAGES, VALIDATION_FIELD_MAPPING, MaxLength, Regex, EXPENSE_CATEGORY } from '../../../../utils/appConstant';

export const validateAddEditForm = (formData: AddEditInterface, fieldToValidate?: string): Validation => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.expenseDetails) {
    if (!formData.expenseDetails) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.expenseDetails,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankExpenseDetails,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.transactionDate) {
    if (!formData.transactionDate) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.transactionDate,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankTransactionDate,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.propertyId) {
    if (formData.expenseCategory !== EXPENSE_CATEGORY.internalExpense && !formData.propertyId) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.propertyId,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankProperty,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.paidBy) {
    if (!formData.paidBy) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.paidBy,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankPaidBy,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.managerId) {
    if (formData.expenseCategory === EXPENSE_CATEGORY.internalExpense && !formData.managerId) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.managerId,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankManager,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.transactionType) {
    if (!formData.transactionType) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.transactionType,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankTransactionType,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.carryforwardInvoiceNo) {
    if (formData.carryforwardInvoiceNo?.trim() && formData.carryforwardInvoiceNo.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.carryforwardInvoiceNo,
        message: APP_ERROR_MESSAGES.transactions.addEdit.maxLengthExceeded,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.reservationId) {
    if (formData.adjustAgainstClaim && !formData.reservationId) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.reservationId,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankReservation,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.claimNumber) {
    if (formData.adjustAgainstClaim && formData.claimNumber?.trim() && formData.claimNumber.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.claimNumber,
        message: APP_ERROR_MESSAGES.transactions.addEdit.maxLengthExceeded,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.claimAmountReceived) {
    if (formData.expenseCategory !== EXPENSE_CATEGORY.internalExpense && formData.adjustAgainstClaim && formData.claimSettled) {
      const claimAmount = String(formData.claimAmountReceived ?? "").trim();
      if (!claimAmount) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.claimAmountReceived,
          message: APP_ERROR_MESSAGES.transactions.addEdit.blankClaimAmountReceived,
        });
      } else if (!Regex.floatValues.test(claimAmount) || parseFloat(claimAmount) < 0) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.claimAmountReceived,
          message: APP_ERROR_MESSAGES.transactions.addEdit.invalidClaimAmountReceived,
        });
      }
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.actualCost) {
    if (formData.actualCost && !Regex.floatValues.test(formData.actualCost.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.actualCost,
        message: APP_ERROR_MESSAGES.transactions.addEdit.invalidActualCost,
      });
    } else {
      const numValue = parseFloat(formData.actualCost);
      if (numValue < 0) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.actualCost,
          message: APP_ERROR_MESSAGES.transactions.addEdit.invalidActualCost,
        });
      }
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.totalAmount) {
    if (!formData.totalAmount) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.totalAmount,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankTotalAmount,
      });
    } else if (!Regex.floatValues.test(formData.totalAmount.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.totalAmount,
        message: APP_ERROR_MESSAGES.transactions.addEdit.invalidTotalAmount,
      });
    } else {
      const numValue = parseFloat(formData.totalAmount);
      if (numValue < 0) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.totalAmount,
          message: APP_ERROR_MESSAGES.transactions.addEdit.invalidTotalAmount,
        });
      }
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.subTotal) {
    if (!formData.subTotal) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.subTotal,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankSubTotal,
      });
    } else if (!Regex.floatValues.test(formData.subTotal.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.subTotal,
        message: APP_ERROR_MESSAGES.transactions.addEdit.invalidSubTotal,
      });
    } else {
      const numValue = parseFloat(formData.subTotal);
      if (numValue < 0) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.subTotal,
          message: APP_ERROR_MESSAGES.transactions.addEdit.invalidSubTotal,
        });
      }
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.reviewed || fieldToValidate === VALIDATION_FIELD_MAPPING.reviewedBy) {
    const reviewed = !formData.reviewed;
    if (reviewed && !formData.reviewedBy) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.reviewedBy,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankReviewedBy
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.receiptLink) {
    if (formData.receiptLink?.trim() && !Regex.url.test(formData.receiptLink.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.receiptLink,
        message: APP_ERROR_MESSAGES.transactions.addEdit.invalidReceiptLink,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.reviewed || fieldToValidate === VALIDATION_FIELD_MAPPING.notes) {
    if (!formData.reviewed && !formData.notes?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.notes,
        message: APP_ERROR_MESSAGES.transactions.addEdit.blankNotes
      });
    }
  }

  return validations;
};
